module.exports = __webpack_public_path__ + "assets/306b0faa4569f8190709b7362316701b.svg";